import React from 'react';
import moment from 'moment';
import { regstrSlotConst } from '../../helpers/ConstantID';

export default function DatePickerDesktop(props) {
	return (
		<table>
			<thead>
				<tr>
					<th>
						<div className="arrowleft" onClick={props.arrowLeftClick}>
							<i className="fas fa-angle-left" />
						</div>
					</th>
					{props.day.map((v, i) => {
						return (
							<th key={i} id={`${regstrSlotConst.sh_lg_registerslot_date}${i}`}>
								<div className="table-heading-month">
									{props.date[i].date.replace(/\D/g, '')}{' '}
									<span>{props.date[i].date.replace(/[0-9]/g, '')}</span>
								</div>
								<div className="table-heading-day">{v.desktop}</div>
								{/* <div className="table-heading-date"></div> */}
							</th>
						);
					})}
					<th>
						<div className="arrowright" onClick={props.arrowRightClick}>
							<i className="fas fa-angle-right" />
						</div>
					</th>
				</tr>
			</thead>

			<tbody>
				{props.array[0].map((v, u) => {
					return (
						<tr key={u}>
							<td>
								<div className="table-heading-time">
									<span>{moment(v.hour).format('h A')}</span>
									<span>{moment(v.hour).format('hh:mm A')}</span>
								</div>
							</td>
							{props.array.map((v, i) => {
								return (
									<td
										key={i}
										className={`${props.isDrageStart ? 'resize-cursor' : ''}`}
										id={`slot-${i}-${u}-${v[u].hour}`}
									>
										<div
											className={v[u].project ? 'tp': ''}
											key={i}
										>
											{/* Resize Handle */}
											{v[u] && !v[u].disabled && v[u].checked &&
												<div
													className="resize-handle"
													onMouseDown={(e) => props.handleResizeStart(e, i, u)}
												/>
											}
											<span class="tooltiptext sh-table-tooltip" style={{ display: `${props.isDrageStart ? 'none' : 'flex' }` }}>
												{v[u].project && v[u].project.split(",").map(v=>{
													return( <span>{v}</span> )
												})}
											</span>
											<div
												style={props.isSlotSelected(v[u], props.isDrageStart)}
												onClick={(e) => props.handleChange(v[u].hour, i, u)}
											>
												<span
													id={`${regstrSlotConst.sh_lg_registerslot_time}${u}${i}`}
													className="sh-overflow-text"
													style={
														v[u].disabled || v[u].checked
															? { visibility: 'visible' }
															: { visibility: 'hidden' }
													}
												>
													{''}
													{v[u].project ? v[u].project : moment(v[u].hour).format('hh:mm A')}
												</span>
											</div>
										</div>
									</td>
								);
							})}
							<td>
								<span>{''}</span>
							</td>
						</tr>
					);
				})}
			</tbody>
		</table>		
	);
}



// WEBPACK FOOTER //
// ./src/screens/CounselorDatePicker/DatePickerDesktop.js